export default "__VITE_ASSET__BUKu_UqR__"